import SledovanyLegislativnyMaterialList from './SledovanyLegislativnyMaterialList';

export default SledovanyLegislativnyMaterialList;
